import React from 'react';
import CertifacteHeader from './CertifacteHeader';
import { Box, CircularProgress, Typography } from '@mui/material';

import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../links/API_LINKS';

const Index = ({ batchData }) => {
  const fetchLeaderboard = async () => {
    const res = await axios.get(
      API_URL + '/dashboard/partner/vga-certificate',
      {
        params: { batchId: batchData._id },
      }
    );
    return res;
  };

  const { status, data } = useQuery(
    `certificate${batchData._id}`,
    fetchLeaderboard
  );
  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <Typography>Error fetching data</Typography>}
      {status === 'success' && (
        <CertifacteHeader
          batchData={batchData}
          userData={data?.data?.data || []}
        />
      )}
    </div>
  );
};

export default Index;
